import { TsLinkUser } from './../model/ts-link-user.model';
import { UserInfo } from './../model/user-info.model';
import { Injectable } from '@angular/core';
import { BaseStateModel } from './base-state.model';
import { StateToken, State, Action, StateContext, Selector } from '@ngxs/store';
import { BaseStateActions } from './base.actions';

const BASESTATE_TOKEN: StateToken<BaseStateModel> = new StateToken('basestate');

const DEFAULT_STATE: BaseStateModel = {
    token: undefined,
    userInfo: undefined,
};

@State<BaseStateModel>({
    name: BASESTATE_TOKEN,
    defaults: DEFAULT_STATE,
    children: [], //ce bo kdaj prov prislo
})
@Injectable()
export class BaseState {
    // private selectedContractor: Contractor = this.store.selectSnapshot(BaseState.activeContractor);

    constructor() {}

    @Selector([BASESTATE_TOKEN])
    public static getToken(state: BaseStateModel): string {
        return state.token;
    }

    @Selector([BASESTATE_TOKEN])
    public static GetUserInfo(state: BaseStateModel): TsLinkUser {
        return state.userInfo;
    }

    @Action(BaseStateActions.ClearBaseState)
    public ClearState(ctx: StateContext<BaseStateModel>, {}: BaseStateActions.ClearBaseState) {
        ctx.patchState(DEFAULT_STATE);
    }

    @Action(BaseStateActions.Common.SetToken)
    public SetToken(ctx: StateContext<BaseStateModel>, { token }: BaseStateActions.Common.SetToken) {
        ctx.patchState({ token: token });
    }

    @Action(BaseStateActions.Common.SetUserInfo)
    public SetUserInfo(ctx: StateContext<BaseStateModel>, { userInfo }: BaseStateActions.Common.SetUserInfo) {
        ctx.patchState({ userInfo: userInfo });
    }
}
